import { render, staticRenderFns } from "./WebUrl.vue?vue&type=template&id=5f5d232f&scoped=true&"
import script from "./WebUrl.vue?vue&type=script&lang=js&"
export * from "./WebUrl.vue?vue&type=script&lang=js&"
import style0 from "./WebUrl.vue?vue&type=style&index=0&id=5f5d232f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5d232f",
  null
  
)

export default component.exports